module.exports = __webpack_public_path__ + "static/img/icon4.c95a4ed5.svg";